"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubConnaissancesMarcheFinancierProduitsEpargneCorporationTrads = void 0;
exports.ESubConnaissancesMarcheFinancierProduitsEpargneCorporationTrads = {
    aucune: "Aucune",
    eleve: "Elevé (ayant une bonne connaissance et ayant une solide expérience professionnelle dans le secteur financier)",
    expert: "Expert (une connaissance de spécialiste des instruments financiers complexes)",
    faible: "Faible (débutant)",
    moyenne: "Moyenne (intermédiaire)",
};
